import config from "../../app.json";
import axios from "axios";

import { Context } from "../../Reducers/Store";
import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import FieldText from "../../Components/Fields/FieldText";
import { Row, Col } from "react-bootstrap";
import styled from "styled-components";

import AlertComponent from "../../Components/AlertComponent";
import cellPhoneImage from "../../Assets/Images/cellphone.png";

import CsWhiteLogo from "../../Assets/Svgs/cs-white-logo.svg";
import AwsLogo from "../../Assets/Svgs/aws-logo.svg";

import ReCAPTCHA from "react-google-recaptcha";

function Register(props) {
  const { id } = props;
  const [state, dispatch] = useContext(Context);
  const [firstName, setFirstName] = useState(null);
  const [firstNameError, setFirstNameError] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [lastNameError, setLastNameError] = useState(null);
  const [email, setEmail] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [password, setPassword] = useState(null);
  const [passwordError, setPasswordError] = useState(null);
  const [repeatPassword, setRepeatPassword] = useState(null);
  const [repeatPasswordError, setRepeatPasswordError] = useState(null);
  const [recaptchaCode, setRecaptchaCode] = useState(null);

  let location = useLocation();
  let navigate = useNavigate();
  let from = location.state?.from?.pathname || "/";

  const Logo = styled.img`
    width: auto;
    margin: 0 auto;
  `;

  if (state.isLogged) {
    navigate("/codeVerification", { replace: true });
    return;
  }

  const fetchProfile = (token) => {
    let configRequest = { headers: { Authorization: "Bearer " + token } };
    axios
      .post(config.API + "/api/user/getProfile", null, configRequest)
      .then((res) => {
        dispatch({ type: "SET_LOGGED", payload: { jwt: token, profile: res.data }, });
        return navigate("/codeVerification", { replace: false });
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message,
          { icon: `error` }
        );
      });
  };

  const handleRegister = (e) => {
    e.preventDefault();
    if (!recaptchaCode)
      return AlertComponent("Error", "Please verify that you are human by completing the reCAPTCHA.", { icon: `error` });
    else if (!firstName) 
      setFirstNameError("First Name is required");
    else if (!lastName) {
      setFirstNameError(null);
      setLastNameError("Last Name is required");
    } else if (!email) {
      setLastNameError(null);
      setEmailError("E-mail is required");
    } else if (!password) {
      setEmailError(null);
      setPasswordError("Password is required");
    } else if (!repeatPassword) {
      setPasswordError(null);
      setRepeatPasswordError("Repeat Password is required");
    } else if (password != repeatPassword)
      setRepeatPasswordError("Passwords do NOT match");
    else {
      setRepeatPasswordError(null);

      axios
        .post(config.API + "/api/user/createUser", {
          firstName,
          lastName,
          email,
          password,
          recaptchaCode
        })
        .then((res) => {
          if (res.status === 200) {
            fetchProfile(res.data.token);
          } else
            return AlertComponent("Error", res.data.message || res.data.error, {
              icon: `error`,
            });
        })
        .catch(function (error) {
          return AlertComponent(
            "Error",
            error?.response?.data?.error ||
            error?.response?.data?.message ||
            error?.message,
            { icon: `error` }
          );
        });
    }
  };

  return (
    <div className="prelogin-container">
      <div className="containerLoginForm">
        <Row className="header-login">
          <Col className="col-md-6">
            <img className="cs-logo-login" src={CsWhiteLogo} />
          </Col>
          <Col className="col-md-6">
            <img className="aws-logo-login" src={AwsLogo} />
          </Col>
        </Row>
        <Row className="login-body">
          <Col className="col-md-7 cs-3d-phone">
            <iframe
              src="https://my.spline.design/untitled-c751e6b7fc77254e43fcafa257e796e6/"
              frameBorder="0"
              width="100%"
              height="100%"
            ></iframe>
          </Col>
          <Col className="col-md-5 cs-login-form">
            <h2>Welcome</h2>
            <form onSubmit={handleRegister} className="form-login">
              <Row>
                <Col className="col-md-6">
                  <FieldText
                    label="First Name"
                    type="text"
                    onChange={(x) => setFirstName(x.target.value)}
                    placeholder="First Name"
                    value={firstName}
                    error={firstNameError}
                    required={true}
                    inputClassName={`inputOption`}
                    className="first-name-field"
                  />
                </Col>
                <Col className="col-md-6">
                  <FieldText
                    label="Last Name"
                    type="text"
                    onChange={(x) => setLastName(x.target.value)}
                    placeholder="Last Name"
                    value={lastName}
                    error={lastNameError}
                    required={true}
                    inputClassName={`inputOption`}
                    className="last-name-field"
                  />
                </Col>
              </Row>
              <Row>
                <Col className="col-md-12">
                  <FieldText
                    label="E-mail"
                    type="email"
                    onChange={(x) => setEmail(x.target.value)}
                    placeholder="Type your email"
                    value={email}
                    error={emailError}
                    required={true}
                    inputClassName={`inputOption`}
                    className="email-field"
                  />
                </Col>
              </Row>
              <Row>
                <Col className="col-md-6">
                  <FieldText
                    label="Password"
                    type="password"
                    placeholder="Password"
                    onChange={(x) => setPassword(x.target.value)}
                    value={password}
                    className="password-field"
                    error={passwordError}
                    required={true}
                    inputClassName={`inputOption passwordInput`}
                  />
                </Col>
                <Col className="col-md-6">
                  <FieldText
                    label="Confirm Password"
                    type="password"
                    placeholder="Confirm password"
                    onChange={(x) => setRepeatPassword(x.target.value)}
                    value={repeatPassword}
                    className="password-field"
                    error={repeatPasswordError}
                    required={true}
                    inputClassName={`inputOption passwordInput`}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="col-md-12" style={{ justifyContent: 'center', alignContent: 'center', display: 'flex', marginTop: 20 }}>
                  <ReCAPTCHA
                    sitekey={config.GOOGLE_RECAPTCHA_API_KEY}
                    onChange={(value) => {
                      console.log("Captcha value:", value);
                      setRecaptchaCode(value);
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="col-md-12">
                  <div className="form-group mt-3 loginAlignCenter">
                    <button type="submit" className="btn submitLogin col-md-12">
                      Sign Up
                    </button>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="col-md-12">
                  <div className="loginAlignCenter">
                    <span className="signUpText">
                      Already have an account?{" "}
                      <a
                        className="signUpLink"
                        onClick={() => navigate("/login", { replace: false })}
                      >
                        Sign In
                      </a>
                    </span>
                  </div>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Register;
